import React, { useState, useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Menu, MenuItem, Box, Typography, Divider } from "@mui/material";
import { useMediaQuery, useTheme } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./navbar.module.css";
import { DataContext } from "../../context/dataprovider.js"; // Import DataContext
import apiClient from "../../api/Api.js";
import EmailIcon from "@mui/icons-material/Email";
import BadgeIcon from "@mui/icons-material/Badge";

const Navbar = () => {
  const { userData, role } = useContext(DataContext); // Consume userData from context
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const REACT_APP_BASE_API = process.env.REACT_APP_BASE_API;

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDashboard = () => {
    navigate("/dashboard");
  };

  const handleTransactions = () => {
    navigate("/transactions");
  };

  const handleLogOut = async () => {
    try {
      const response = await apiClient.post(
        `${process.env.REACT_APP_AUTH_API}/logout`
      );
      if (response.status === 200) {
        toast.success(response.data.message || "Logout successful!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        localStorage.clear();
        navigate("/");
        setAnchorEl(null);
      } else {
        toast.warn("Unexpected response. Please try again.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } catch (error) {
      console.error("Logout failed:", error);

      toast.error("Failed to logout. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  return (
    <>
      <AppBar position="static" className={styles.appBar}>
        <Toolbar className={styles.toolbar}>
          {isMobile ? (
            <Box className={styles.mobileLogoContainer}>
              <img
                src={`${REACT_APP_BASE_API}/images/Flynexus.jpg`}
                alt="Logo"
                className={styles.logo}
              />
              <Typography variant="h6" className={styles.logoText}>
                FLY NEXUS
              </Typography>
            </Box>
          ) : (
            <Box className={styles.logoContainer}>
              <img
                src={`${REACT_APP_BASE_API}/images/Flynexus.jpg`}
                alt="Logo"
                className={styles.logo}
              />
              <Typography variant="h6" className={styles.logoText}>
                FLY NEXUS
              </Typography>
            </Box>
          )}

          <Box className={styles.menuAndIcons}>
            {!isMobile && (
              <Typography className={styles.greeting}>
                {`Welcome, ${userData.name}`}
              </Typography>
            )}
            <IconButton color="inherit" onClick={handleMenuOpen}>
              <AccountCircleIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Menu for User Icon */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {/* Email and Role Menu Items */}
        <MenuItem disabled>
          <EmailIcon sx={{ mr: 1, color: "text.secondary" }} />
          <Typography variant="body1" color="text.primary">
            {userData.email}
          </Typography>
        </MenuItem>

        <MenuItem disabled>
          <BadgeIcon sx={{ mr: 1, color: "text.secondary" }} />
          <Typography variant="body1" color="text.primary">
            {userData.role}
          </Typography>
        </MenuItem>

        <Divider />

        {/* Dynamic Menu Items Based on Current Path */}
        {userData.role !== role.roles_6 &&
          (location.pathname === "/dashboard" ? (
            <MenuItem onClick={handleTransactions}>Transactions</MenuItem>
          ) : (
            <MenuItem onClick={handleDashboard}>Dashboard</MenuItem>
          ))}

        <MenuItem onClick={handleLogOut}>Log Out</MenuItem>
      </Menu>
    </>
  );
};

export default Navbar;
